export enum BrandTileSurfaceContainer {
  BRAND_TILE_SURFACE_CONTAINER_UNKNOWN = 'BRAND_TILE_SURFACE_CONTAINER_UNKNOWN',
  ASSORTMENT_PAGE_BRANDS = 'ASSORTMENT_PAGE_BRANDS',
  MARKET_LIST_PAGE_NOW_ON_FAIRE_BRANDS = 'MARKET_LIST_PAGE_NOW_ON_FAIRE_BRANDS',
  POST_CHECKOUT_PAGE_NOW_ON_FAIRE_BRANDS = 'POST_CHECKOUT_PAGE_NOW_ON_FAIRE_BRANDS',
  BUILDER_IO_BRANDS = 'BUILDER_IO_BRANDS',
}
